import React from 'react';

import OrdersTable from './orders_table/OrdersTable';
import useOrders from '../../../hooks/useOrders';

export default function OrderDashboard({ props }) {
  const { orders, ordersLoading, pageCount, fetchData } = useOrders(props);
  const totalRows = props?.stats?.active + props?.stats?.closed;

  return (
    <div className="my-4 md:my-8">
      <OrdersTable
        orders={orders}
        ordersLoading={ordersLoading}
        totalRows={totalRows}
        pageCount={pageCount}
        fetchData={fetchData}
      />
    </div>
  );
}
